// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"eb85c66c51c1a9c5","8457":"3f9994b493cdbf10"}[chunkId] + ".css";
};